<template>
    <div class="main">
        <div class="guding" v-show="!SHOW_SEL">
            <ul class="tctype">
                <li v-for="(li,index) in CATEGORYS" :key="index"><button type="button" @click="begreen(index)" :class="{green:changeGreen==index}"> {{li.CAT_NAME}}</button></li>
            </ul>
            <div class="tc">
                <div class="tctitle">
                    <b></b><span>套餐列表</span><b></b>
                </div>
                <div>
                    <ul>
                        <li v-for="(li,index) in COMBOS" :key="index">
                            <div class="container">
                                <div class="left" @click="yuyue(li)"><img src="../assets/images/tc4.jpg" alt=""></div>
                                <div class="right">
                                    <div @click="yuyue(li)">
                                        <h3>{{li.COMBO_NAME}}</h3>
                                    </div>
                                    <div @click="yuyue(li)" class="price">￥{{li.PRICE}}</div>
                                    <div class="icons">
                                        <!-- <i class="iconfont icon-star-copy"></i> -->
                                        <i class="iconfont icon-gouwuche" @click="goShopCart(li)"></i>
                                        <button type="button" @click="yuyue(li)">立即购买</button>
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="personsel" v-show="SHOW_SEL">
            <personSel @INDIVIDUAL="selPerson" :action-type="ACTION" :combo-sex="COMBO.COMBO_SEX" :combo-type="2"></personSel>
        </div>
    </div>
</template>

<script>
    import api from "@/fetch/api";
    import personSel from '@/pages/personSel'
    import {
        mapGetters
    } from 'vuex';
     import {
        Toast
    } from 'vant';
    export default {
        data() {
            return {
                CATEGORYS: [],
                COMBOS: [],
                changeGreen: 0,
                customerID: '',
                SHOW_SEL: false,
                ACTION: 1, //1:购物车，5：待付款
                COMBO: { //选中的套餐
                    COMBO_SEX: -1, //套餐适用性别
                    COMBO_ID: '', //选中的套餐ID
                    PRICE: 0
                }
            }
        },
        components: {
            personSel
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getUID(vm)
            })
        },
        created() {
            window.scroll(0, 0);
            api.getComboCat().then(res => {
                res.data.forEach(el => {
                    this.CATEGORYS.push({
                        COMBOCATEGORY_ID: el.COMBOCATEGORY_ID,
                        CAT_NAME: el.CAT_NAME,
                        CAT_DESC: el.CAT_DESC
                    });
                });
                // this.CATEGORYS.push({
                //     COMBOCATEGORY_ID: '7128312313',
                //     CAT_NAME: '李雷and韩梅梅套餐（青少年）',
                //     CAT_DESC: 'balabala'
                // }, {
                //     COMBOCATEGORY_ID: '3131231241',
                //     CAT_NAME: '潘多拉套餐（基因防癌）',
                //     CAT_DESC: 'balabala'
                // }, {
                //     COMBOCATEGORY_ID: '31123413231',
                //     CAT_NAME: '鹰眼套餐（PET_CT防癌）',
                //     CAT_DESC: 'balabala'
                // }, {
                //     COMBOCATEGORY_ID: '31321411541',
                //     CAT_NAME: '团检套餐（PET_CT防癌）',
                //     CAT_DESC: 'balabala'
                // });
                return this.CATEGORYS[0].COMBOCATEGORY_ID;
            }).then(v => {
                api.getComboInfo(v).then(re => {
                    console.log(re.data);
                    re.data.forEach(el => {
                        this.COMBOS.push({
                            MOBILECOMBO_ID: el.MOBILECOMBO_ID,
                            COMBO_NAME: el.COMBO_NAME,
                            COMBO_DESC: el.COMBO_DESC,
                            PRICE: el.PRICE,
                            COMBO_SEX: el.COMBO_SEX
                        });
                    })
                })
            });
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        },
        methods: {
            getUID(el) {
                this.customerID = el.$route.params.customerID;
            },
            yuyue: function(li) {
                this.$router.push({
                    path: '/user/tcjx/' + li.MOBILECOMBO_ID,
                    query: {
                        sex: li.COMBO_SEX
                    }
                });
            },
            begreen(index) {
                this.changeGreen = index;
                api.getComboInfo(this.CATEGORYS[index].COMBOCATEGORY_ID).then(re => {
                    this.COMBOS = [];
                    re.data.forEach(el => {
                        this.COMBOS.push({
                            MOBILECOMBO_ID: el.MOBILECOMBO_ID,
                            COMBO_NAME: el.COMBO_NAME,
                            COMBO_DESC: el.COMBO_DESC,
                            PRICE: el.PRICE,
                            COMBO_SEX: el.COMBO_SEX
                        });
                    })
                });
            },
            selPerson(val) {
                this.SHOW_SEL = false;
                if (val != '' && val.INDIVIDUAL_ID != '' && val.INDIVIDUAL_ID != undefined) {
                    let customerID = val.INDIVIDUAL_ID;
                    let addItemIDs = [];
                    if (val.ACTIONTYPE == 1) {
                        //加入购物车
                        let params = {
                            COMBO_ID: this.COMBO.COMBO_ID,
                            addItemId: addItemIDs,
                            STATUS: 1,
                            PRICE: this.COMBO.PRICE,
                            TYPE: 2
                        };
                        console.log(customerID);
                        console.log(this.userInfo.CUSTOMER_ID);
                        console.log(params);
                        api.weixinOrder(customerID, this.userInfo.CUSTOMER_ID, params)
                            .then(res => {
                                console.log(res);
                                if (res.result == true) {
                                    Toast.success('添加购物车成功');
                                }
                            });
                    }
                }
            },
            goShopCart(li) {
                this.COMBO = {
                    COMBO_SEX: parseInt(li.COMBO_SEX),
                    COMBO_ID: li.MOBILECOMBO_ID,
                    PRICE: li.PRICE
                };
                //加入购物车
                window.scroll(0, 0);
                this.SHOW_SEL = true;
                
            },
        }
    }
</script>

<style scoped lang="less">
    .guding {
        font-size: 0.8rem; // margin: 0.5rem 0.5rem;
        background-color: #f0f0f0;
        font-family: "Microsoft YaHei";
        .tctype {
            zoom: 1;
            margin: 0 0 10px 0;
            background-color: #fff;
            padding: 10px 5px 10px 5px;
            li {
                // height: 4em;
                width: 32%;
                float: left;
                margin: 0 0 1% 1%;
                button {
                    // width: 5.1em; 
                    width: 100%;
                    height: 5em;
                    background: inherit;
                    background-color: rgba(255, 255, 255, 1);
                    box-sizing: border-box;
                    border-width: 1px;
                    border-style: solid;
                    border-color: #74b13f;
                    border-radius: 10px;
                    box-shadow: none;
                    color: #74b13f;
                    text-align: center;
                    font-size: 1em;
                    padding: 0;
                }
                .green {
                    background: #74b13f;
                    color: #fff;
                }
            }
        }
        ul:after {
            display: block;
            clear: both;
            height: 0;
            content: '.';
            visibility: hidden;
        }
        .tc {
            // margin-top: 1rem; 
            color: #000;
            background-color: #f0f0f0;
            .tctitle {
                text-align: center;
                background-color: #fff;
                line-height: 3rem;
                b {
                    display: inline-block;
                    width: 4rem;
                    height: 1px; // background-color: #FF9966;
                    background-color: #000;
                    vertical-align: middle;
                    margin: 0 1rem;
                }
                span {
                    font-size: 1rem;
                    font-family: "Microsoft YaHei" !important;
                    font-weight: 500;
                }
            }
            li {
                // width: 100%;
                height: 5.5rem;
                margin-bottom: 1px;
                padding: 10px;
                background-color: #fff;
            }
            .container {
                zoom: 1; // background-color: rgba(242, 242, 242, 1);
                border: none;
                border-radius: 0px;
                box-shadow: none;
                .left {
                    width: 6.5rem;
                    float: left;
                    height: 5.5rem;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .right {
                    margin-left: 10em;
                    height: 5.5rem;
                    position: relative;
                    h3 {
                        margin: 0;
                        padding-top: 0.5em;
                        font-weight: 500;
                    }
                    .price {
                        // text-align: right;
                        // margin-right: 1em;
                        color: rgb(255, 85, 0);
                        font-family: "Microsoft YaHei";
                        font-size: 1rem;
                        line-height: 2rem;
                    }
                    .icons {
                        text-align: right; // padding-right: 2rem;
                        button {
                            background: inherit;
                            background-color: #aacd06;
                            box-sizing: border-box;
                            border-width: 1px;
                            border-style: solid;
                            border-radius: 6px;
                            box-shadow: none;
                            text-align: center;
                            font-size: 0.8rem;
                            height: 2.4em;
                            width: 5rem;
                            color: #fff;
                            border-color: #aacd06; // position: absolute;
                            // right: 2rem;
                        }
                    }
                    .icons i {
                        color: #619534; // margin-left: 1rem;
                        font-size: 1.6rem;
                        letter-spacing: 0.6em;
                        vertical-align: middle;
                    }
                }
            }
            .container::after {
                display: block;
                clear: both;
                height: 0;
                content: '.';
                visibility: hidden;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/gudingtc.vue